// extracted by mini-css-extract-plugin
export var block = "Content-module--block--MeyUO";
export var quote = "Content-module--quote--dkQS1";